import React, { useState } from "react";
import {
  DialogContent,
  Typography,
  Grid,
  Divider,
  useMediaQuery,
  useTheme
} from "@material-ui/core";

import { isMobile } from "react-device-detect";

import { Close } from "@material-ui/icons";

import useStyles from "./style";

export default function HelpPopup({ url }) {

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down(960));

  const [sk, setSk] = useState([
    "Dibuka untuk umum, dengan syarat harus mendaftar menjadi seller Tokorame",
    "Laki-Laki / Perempuan",
    "Tidak ada Batasan usia",
    "Digital sketch",
    "Desain sketsa berwarna, dengan informasi bahan juga (Jika karya manual harus di scan)",
    "Filosofi / moodboard / storyboard / alasan atau referensi mengapa design tersebut dibuat (PDF)",
    "Pemenang berdasarkan vote dari jaringan Tokorame dan juga dari juri Tokorame",
    "Keputusan juri tidak dapat diganggu gugat",
  ]);

  return (
    <>
      <DialogContent
        style={{
          padding: 0,
          minHeight: "450px",
        }}
      >
        <Grid
          container
          spacing={2}
          style={{
            width: "100%",
            margin: "0",
          }}
        >
          {(!isMobile && !fullScreen) ? (
            <Grid
              item
              md={6}
              xs={12}
              style={{
                backgroundColor: "#5675D3",
                width: "100%",
                height: "450px",
                padding: 0,
              }}
            >
              {url ? (
                <img
                  src={url}
                  alt="background"
                  style={{
                    width: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                ""
              )}
            </Grid>
          ) : (
            ""
          )}

          <Grid item md={6} xs={12}>
            <Typography
              variant="h5"
              style={{
                marginBottom: "10px",
              }}
            >
              Syarat & Ketentuan
            </Typography>
            <Divider />
            <ol
              type="1"
              style={{
                paddingLeft: "20px",
              }}
            >
              {sk.map((item) => {
                return (
                  <li>
                    <Typography variant="subtitle2">{item}</Typography>
                  </li>
                );
              })}
            </ol>
          </Grid>
        </Grid>
      </DialogContent>
    </>
  );
}
